import { HttpErrorResponse } from '@angular/common/http';

export enum AUTH_ERRORS {
	ACCOUNT_NOT_FOUND = 'ACCOUNT_NOT_FOUND', /* Account with given name not found */
	ACCOUNT_NOT_EXISTS = 'ACCOUNT_NOT_EXISTS', /* Account with given name not exist */
	CARD_NOT_FOUND = 'CARD_NOT_FOUND', /* Card with given number not found for given account */
	UPLOAD_BY_DRIVER_NOT_ALLOWED = 'UPLOAD_BY_DRIVER_NOT_ALLOWED', /* Account with given name does not allow uploads by driver */
	ACCOUNT_BLOCKED = 'ACCOUNT_BLOCKED', /* Account is blocked */
	MAINTENANCE = 'MAINTENANCE', /* Maintenance of the system */
	INVALID_TOKEN = 'INVALID_TOKEN', /* Invalid token */
	INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR', /* Internal server error */
	BAD_REQUEST = 'BAD_REQUEST', /* Auth token not provided */
	UNKNOWN = 'UNKNOWN'  /* Unknown error occured */
}

export interface RedirectionError {
	url: string;
}

export interface AuthErrorResponse extends HttpErrorResponse {
	error: AUTH_ERRORS | RedirectionError;
}

export interface AuthErrorModel {
	error: AUTH_ERRORS;
	url?: string | null;
}
